<template>
	<fragment>
		<common-header
			subname="팝업 관리"
			name="누리집 팝업 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			:searchbox="false"
			:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav">
				&nbsp;
			</nav>

			<div class="container-fiuld clearfix">
				<table class="table2 m-t-10 text-center">
					<thead>
						<tr class="bg-lightgray">
							<th>글번호</th>
							<th>작성일시</th>
							<th>제목</th>
							<th>노출</th>
							<th>관리</th>
						</tr>
					</thead>
					<tbody v-for="(popup,index) in popupList" :key="`popup-list-${hash(popup)}`">
						<tr class="margin">
							<td colspan="6"></td>
						</tr>
						<tr>
							<td>
								{{totalCount - offset - index}}
							</td>
							<td>
								{{moment(popup.regDate).format("YYYY-MM-DD HH:mm:ss")}}
							</td>
							<td>
								{{popup.title}}
							</td>
							<td class="w200">
								<select class="form-control-sm full-width round" v-model="popup.showEnable" @change="modifyShowEnable(popup, $event)">
									<option value="1">노출</option>
									<option value="0">노출안함</option>
								</select>
							</td>
							<td>
								<a class="modify m-r-10" @click="modifyPopup(popup)">수정</a>
								<a class="del" @click="removePopup(popup)">삭제</a>
							</td>
						</tr>
					</tbody>
				</table>


				<ctrl-pagination :currentPage="offset / pageSize + 1"
					:pageSize="pageSize" :totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"></ctrl-pagination>
			</div>
		</section>
	
		<common-footer></common-footer>

		<modal-popup-register ref="register" :config="modals.ModalPopupRegister" @close="modals.ModalPopupRegister.show=false;" @onDone="onDone" @onRefresh="onRefresh"></modal-popup-register>
		<modal-popup-modify ref="modify" :popup="selectPopup" :config="modals.ModalPopupModify" @close="modals.ModalPopupModify.show=false;" @onDone="onDone" @onRefresh="onRefresh"></modal-popup-modify>
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalPopupRegister from '../modals/ModalPopupRegister.vue'
import ModalPopupModify from '../modals/ModalPopupModify.vue'

import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import Axios from 'axios'
import server from '../statics/server'

export default {
	name: "ViewPopupManager",
	mixins: [fnAdjustHeight],
	components: {
		ModalConfirm,
		ModalAlert,
		ModalPopupRegister,
		ModalPopupModify,

		CommonHeader,
		CommonFooter,
		CtrlPagination,
	},

	mounted: function() {
		this.getPopupList();
	},

	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalPopupRegister: ModalPopupRegister.default(),
				ModalPopupModify: ModalPopupModify.default()
			},
			menus: [ // 서브메뉴
				{name:'누리집 팝업 관리',link:"/popup",selected:true},
			],
			buttons: [ // 헤더버튼
				{name:'새 팝업 만들기',fn:()=>{ this.openRegisterModal() }}
			],
			popupList : [],
			totalCount: 0,
			pageSize: 10,
			offset: 0,

			selectPopup: null
		}
	},

	methods: {
		openRegisterModal: function() {
			this.modals.ModalPopupRegister.show = true;
			this.$refs.register.editorInit();
			
		},
		getPopupList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.POPUP}`, {});
				this.popupList = data.list.map(e=>{
					e.selected = false;
					return e;
				});
				this.totalCount = parseInt(data.filtered);
			} catch (e) {
				// TODO: error exception
			}
		},
		modifyShowEnable: async function(popup, $event) {
			const { value: enable } = $event.target;
			try{
				await Axios.patch(`${server.addr()}${server.api.POPUP}/${popup.popupId}`, {
					showEnable: enable
				});
			} catch (e) {
				// TODO: error exception
			}
		},
		modifyPopup: function(popup) {
			this.selectPopup = popup;
			this.modals.ModalPopupModify.show = true;
			this.$refs.modify.editorInit();
		},
		removePopup: function(popup) {
			this.modals.ModalConfirm.msg = "정말로 삭제하시겠습니까?";
			this.modals.ModalConfirm.show = true;
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = async () => {
				try{
					await Axios.delete(`${server.addr()}${server.api.POPUP}/${popup.popupId}`);
					this.getPopupList();
					this.modals.ModalAlert.msg = "삭제되었습니다.";
					this.modals.ModalAlert.show = true;
					this.modals.ModalConfirm.show = false;
				} catch (e) {
					// TODO: error exception
				}
			}
		},
		onDone: function({msg, fn}) {
			this.modals.ModalAlert.msg = msg;
			this.modals.ModalAlert.show = true;
			this.modals.ModalAlert.btn.fn = ()=> { fn(); this.modals.ModalAlert.show = false; }
		},
		onRefresh: function() {
			this.getPopupList();
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getPopupList();
		},
	},
	computed: {
		allSelected: function() {
			const isAllSelected = this.popupList.reduce((prev, curr) => prev && curr.selected , true);
			return isAllSelected;
		}
	}
}
</script>